let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("1ISAt"), load("mKoWX"), load("2AOLi"), load("c6MKV"), load("5TCys")]).then(() => parcelRequire('1wIcl'));